import { useEffect } from 'react'
import { useTelegram } from './use-telegram'

/**
 * Хук для управления SettingsButton в заголовке Telegram (Bot API 7.0+)
 * 
 * SettingsButton - иконка шестерёнки в правом верхнем углу.
 * Используется для быстрого доступа к настройкам приложения.
 * 
 * @param enabled - Показывать ли кнопку настроек
 * @param onClick - Обработчик клика
 * 
 * @example
 * ```tsx
 * // На всех страницах кроме настроек
 * useSettingsButton(true, () => {
 *   router.navigate({ to: '/profile' })
 * })
 * 
 * // Скрыть на странице настроек
 * useSettingsButton(false)
 * ```
 */
export function useSettingsButton(enabled: boolean = true, onClick?: () => void) {
  const { SettingsButton, hapticFeedback } = useTelegram()

  useEffect(() => {
    if (!enabled || !onClick) {
      SettingsButton.hide()
      return
    }

    const handleClick = () => {
      hapticFeedback.impactOccurred('light')
      onClick()
    }

    SettingsButton.show()
    SettingsButton.onClick(handleClick)

    return () => {
      SettingsButton.offClick(handleClick)
      SettingsButton.hide()
    }
  }, [enabled, onClick])
}

